export default __webpack_public_path__ + "static/media/video1.77e26d42.jpg";